import type { ReactNode } from 'react';
import { EmptyState } from '@mokoboko/components';

import { Illustration } from '@/components/illustration';
import type { IllustrationName } from '@/lib/illustrations';
import { mergeClassNames } from '@/lib/utils';

type IllustratedEmptyStateProps = {
  illustration: IllustrationName;
  title: string;
  description: ReactNode;
  primaryAction?: ReactNode;
  className?: string;
  illustrationClassName?: string;
};

// In the studio's own colour through Illustration. The description is balanced
// here because EmptyState's own paragraph is not: a sentence just over the
// column's width otherwise leaves its last word alone on a second line.
export const IllustratedEmptyState = ({
  illustration,
  title,
  description,
  primaryAction,
  className,
  illustrationClassName,
}: IllustratedEmptyStateProps) => (
  <EmptyState
    className={className}
    image={
      <Illustration
        name={illustration}
        alt=""
        width={96}
        height={96}
        className={mergeClassNames(
          'h-24 w-24 object-contain',
          illustrationClassName
        )}
      />
    }
    title={title}
    description={<span className="block text-balance">{description}</span>}
    primaryAction={primaryAction}
    size="md"
  />
);
